import dayjs from "dayjs";

export const CHART_TIME_FRAMES = [
  { value: "event", label: "Event days" },
  { value: "app", label: "All activity" },
  { value: "custom", label: "Custom" },
];

const toDay = (d) => (d ? dayjs(d).format("YYYY-MM-DD") : null);

// Events activated before activatedAt was recorded fall back to createdAt
export const getAppAvailabilityStart = (event) =>
  toDay(event?.activatedAt ?? event?.createdAt);

const eventDayBounds = (event) => {
  const days = (event?.dates ?? [])
    .map((d) => toDay(d.date))
    .filter(Boolean)
    .sort();
  return { from: days[0] ?? null, to: days[days.length - 1] ?? null };
};

// Resolves a { timeFrame, dateFrom, dateTo } selection into concrete
// [from, to] YYYY-MM-DD bounds, mirroring the server's _resolveDateRange.
export const resolveChartRange = (value, event) => {
  const timeFrame = value?.timeFrame ?? "event";
  if (timeFrame === "app") {
    return { from: getAppAvailabilityStart(event), to: toDay(new Date()) };
  }
  if (timeFrame === "custom") {
    return { from: value?.dateFrom || null, to: value?.dateTo || null };
  }
  return eventDayBounds(event);
};

// Keeps rows whose day falls within [from, to] (inclusive). `getDay` maps a row
// to its YYYY-MM-DD; inline it at the call site for hour/epoch buckets.
export const sliceByDay = (rows, { from, to } = {}, getDay = (r) => r.day) =>
  (rows ?? []).filter((r) => {
    const day = getDay(r);
    if (!day) return false;
    return (!from || day >= from) && (!to || day <= to);
  });

// Query params for the ranged (server-side) endpoints. Mirrors the guard the
// page used to apply: an incomplete custom range falls back to the default.
export const toRangeParams = (value) => {
  const timeFrame = value?.timeFrame ?? "event";
  if (timeFrame === "custom") {
    if (!value?.dateFrom || !value?.dateTo) return undefined;
    return { timeFrame, dateFrom: value.dateFrom, dateTo: value.dateTo };
  }
  if (timeFrame === "app") return { timeFrame };
  return undefined;
};

export const formatRange = (from, to) => {
  if (!from || !to) return "";
  const fmt = (s) => dayjs(s).format("DD.MM.YYYY.");
  return `${fmt(from)} – ${fmt(to)}`;
};

// Print caption, e.g. "01.06.2026. – 15.06.2026."
export const describeRange = (value, event) => {
  const { from, to } = resolveChartRange(value, event);
  return formatRange(from, to);
};
